import { noop } from '../app/utils/utils';

const maplibreGl = {
    Map: noop,
    AttributionControl: noop,
    NavigationControl: noop,
    Marker: noop,
    Popup: noop,
};

export default maplibreGl;
